import { render, staticRenderFns } from "./AiConfigTest.vue?vue&type=template&id=3afd7c81&scoped=true"
import script from "./AiConfigTest.vue?vue&type=script&lang=js"
export * from "./AiConfigTest.vue?vue&type=script&lang=js"
import style0 from "./AiConfigTest.vue?vue&type=style&index=0&id=3afd7c81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd7c81",
  null
  
)

export default component.exports